import { ClassTransformOptions, Expose } from 'class-transformer'
import { CartCustomerInput } from 'types/graphql'
import { transformObject } from 'utils/transformObject'

export class CartCustomerInputTransform implements CartCustomerInput {
  @Expose()
  email: string

  @Expose()
  first_name: string

  @Expose()
  last_name: string

  @Expose()
  address_1: string

  @Expose()
  address_2?: string

  @Expose()
  city: string

  @Expose()
  country: string

  @Expose()
  postal_code: string

  @Expose()
  state: string
}

/**
 * Convenience function to transform an unknown object to conform to the CartCustomerInput type
 *
 * @param obj the object you want to transform
 * @param options additional options passed into class-transformer
 * @returns CartCustomerInput with any additional properties present in `obj` omitted
 */
export const transformIntoCartCustomerInput = (obj: Record<string, any>, options: ClassTransformOptions = {}) => {
  return transformObject<CartCustomerInput>(CartCustomerInputTransform, obj, options)
}
